export { default } from './TagGroupField';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/TagGroupField/index.js